// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:39:52

export default {
  "id": "brick-breaker-chipi-chipi-chapa-chapa-cat",
  "slug": "brick-breaker-chipi-chipi-chapa-chapa-cat",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6fe210242c6e45a68a4d78293eb91086-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6fe210242c6e45a68a4d78293eb91086/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Brick Breaker Chipi Chipi Chapa Chapa Cat",
      "description": "Break bricks, collect power-ups for more fun breaking bricks and watch Chipy Chipy Chipa Cat and El Primo Bara Bere dancing. Go through interesting and exciting levels in the fun game about Chippy Chippy Chippy Chappa Chappa Cat and El Primo.\nPass levels of different difficulty and set a personal record.",
      "instructions": "Control the bottom area and hit the balls into the green blocks. Once all the green blocks are destroyed, the level will be completed. Collect falling bonuses in order to increase the number of balls and gain extra life.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "2d",
        "arcade",
        "brickbreaker",
        "levels"
      ]
    },
    "zh-CN": {
      "title": "砖块破坏器奇奇奇帕奇帕猫",
      "description": "打破砖块，收集道具以获得更多乐趣，观看Chipy Chipy Chipa猫和El Primo Bara Bere的舞蹈。在关于Chippy Chippy Chippy Chappa Chappa猫和El Primo的有趣游戏中，通过有趣和刺激的关卡。通过不同难度的关卡，并设置个人记录。",
      "instructions": "控制底部区域，将球击入绿色方块。一旦所有绿色方块被摧毁，关卡即完成。收集下落的奖励以增加球的数量并获得额外生命。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "2D",
        "街机",
        "弹珠台",
        "关卡"
      ]
    },
    "zh-TW": {
      "title": "磚塊破壞 Chipi Chipi Chapa Chapa 猫",
      "description": "打破磚塊，收集增益道具以增添更多破磚的樂趣，欣賞Chipy Chipy Chipa貓與El Primo Bara Bere共舞。通過有趣並充滿挑戰的關卡，遊戲中關於Chippy Chippy Chippy Chappa Chappa貓與El Primo的故事。通過不同難度的關卡，設立個人紀錄。",
      "instructions": "控制底部區域，將球擊入綠色塊。一旦所有綠色塊被摧毀，關卡將會完成。收集下落的獎勵以增加球數並獲得額外生命。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "2D",
        "街機",
        "打破砖塊",
        "關卡"
      ]
    },
    "zh-HK": {
      "title": "砖破器奇皮奇皮查帕查帕貓",
      "description": "打破磚塊，收集增益物品，享受更過癮的破磚體驗，並欣賞 Chipy Chipy Chipa Cat 和 El Primo Bara Bere 跳舞。在關於 Chippy Chippy Chippy Chappa Chappa Cat 和 El Primo 的有趣遊戲中，通過各種有趣和刺激的關卡。通過不同難度的關卡，並設立個人紀錄。",
      "instructions": "控制底部區域，將球擊入綠色塊中。一旦所有綠色塊被摧毀，關卡將完成。收集下落獎勵以增加球數及獲得額外生命。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "2D",
        "街機",
        "打砖塊",
        "關卡"
      ]
    },
    "ja": {
      "title": "ブロック破玉チッピー チッピー チャパチャパ キャット",
      "description": "ブロックを壊して、もっと楽しくブロックを壊すためにパワーアップを収集し、Chipy Chipy Chipa CatとEl Primo Bara Bereが踊るのを見てください。面白いそして刺激的なレベルを通過し、Chippy Chippy Chippy Chappa Chappa CatとEl Primoに関する楽しいゲームを楽しみましょう。異なる難易度のレベルをクリアし、自己記録を更新してください。",
      "instructions": "ボトムエリアを制御し、ボールを緑色のブロックに当ててください。すべての緑色のブロックが破壊されたら、レベルがクリアされます。落ちるボーナスを集め、ボールの数を増やし、エクストラライフを獲得してください。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "2D",
        "アーケード",
        "ブロックブレーカー",
        "レベル"
      ]
    },
    "ko": {
      "title": "브릭브레이커 치피치피 차파차파 캣",
      "description": "브릭을 깨고, 더 재미있게 브릭을 깨기 위한 파워업을 모으세요. 그리고 치피 치피 치파 치파 고양이와 엘 프리모 바라 베가 춤을 추는 것을 보세요. 치피 치피 치파 치파 고양이와 엘 프리모의 재미있고 흥미로운 레벨을 통해 이동하세요.\n다양한 난이도의 레벨을 통과하고 개인 기록을 세세요.",
      "instructions": "하단 영역을 통제하고, 구슬을绿色发展 블록에打进하세요. 모든绿色发展 블록이 파괴되면 레벨이 완료됩니다. 내려오는 보너스를 수집하여 구슬 수를 늘리고 추가 생명을 얻으세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "2D",
        "아케이드",
        "브릭브레이커",
        "레벨"
      ]
    },
    "fr": {
      "title": "Brique Cassante Chipi Chipi Chapa Chapa Chat",
      "description": "Cassez des briques, collectez des power-ups pour plus de fun en cassant des briques et regardez Chipy Chipy Chipa Chat et El Primo Bara Bere danser. Traversez des niveaux intéressants et captivants dans le jeu amusant sur Chippy Chippy Chippy Chappa Chat et El Primo. Passer des niveaux de différentes difficultés et établir un record personnel.",
      "instructions": "Contrôlez la zone inférieure et frappez les balles dans les blocs verts. Une fois tous les blocs verts détruits, le niveau sera terminé. Collectez les bonus tombants pour augmenter le nombre de balles et gagner des vies supplémentaires.",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "2D",
        "arcade",
        "brickbreaker",
        "niveaux"
      ]
    }
  }
};
